import axiosWrapper from '@/utils/request'

const fetchAccessToken = () => {
  return axiosWrapper({
    url: '/v1/access/token'
  })
}

const fetchGEOLocation = (token) => {
  return axiosWrapper({
    headers: {
      Authorization: 'Token ' + token
    },
    url: '/v1/access/geo'
  })
}

const resetPassword = (code, data) => {
  return axiosWrapper({
    method: 'put',
    url: `/v1/access/forgot_passwords/${code}`,
    data
  })
}

const forgotPassword = (data) => {
  return axiosWrapper({
    method: 'post',
    url: '/v1/access/forgot_passwords',
    data
  })
}

const getOTPbyPhone = (publicToken, data) => {
  return axiosWrapper({
    url: 'access/otps',
    headers: { Authorization: 'Token ' + publicToken },
    method: 'post',
    data
  })
}
const fetchEmailFromToken = (publicToken, resetToken) => {
  return axiosWrapper({
    url: `/access/forgot_passwords/email_from_token?token=${resetToken}`,
    headers: { Authorization: 'Token ' + publicToken }
  })
}

export default {
  fetchAccessToken,
  fetchGEOLocation,
  resetPassword,
  forgotPassword,
  getOTPbyPhone,
  fetchEmailFromToken
}
